// import React, { useEffect, useState, useRef } from "react";
// import { FaCalendar, FaTimes } from "react-icons/fa";
// import {
//   Modal,
//   Button,
//   Form,
//   Table,
//   Pagination,
//   Row,
//   Col,
//   Spinner,
// } from "react-bootstrap";
// import axios from "axios";
// import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
// import { RiFilterFill } from "react-icons/ri";
// import { BsFiletypeXls } from "react-icons/bs";
// import Swal from "sweetalert2";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const API_URL = process.env.REACT_APP_API_URL;

// function WithdrawlList() {
//   const [withdrawals, setWithdrawals] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [exporting, setExporting] = useState(false);
//   const [filterFromDate, setFilterFromDate] = useState("");
//   const [filterToDate, setFilterToDate] = useState("");
//   const [filterToType, setFilterToType] = useState("");
//   const datePickerRef = useRef(null);
//   const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
//   const handleIconClick = () => {
//     if (datePickerRef.current) datePickerRef.current.setOpen(true);
//   };
//   const handleClear = () => {
//     setFilterFromDate(null);
//   };

//   const [filters, setFilters] = useState({
//     name: "",
//     account_number: "",
//     status: "",
//   });
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     totalItems: 0,
//     limit: 10,
//   });
//   const [message, setMessage] = useState({ show: false, text: "", type: "" });

//   const [statusModalShow, setStatusModalShow] = useState(false);
//   const [requestToUpdate, setRequestToUpdate] = useState(null);
//   const [approveModalShow, setApproveModalShow] = useState(false);
//   const [paymentUrl, setPaymentUrl] = useState("");
//   const [PaymentMethods, setPaymentMethods] = useState("");
//   const [slipImage, setSlipImage] = useState(null);
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const [remark, setRemark] = useState("");

//   const handleToggle = () => setIsFilterActive(!isFilterActive);

//   const getAuthToken = () => localStorage.getItem("token");

//   const showMessageModal = (text, type = "success") => {
//     setMessage({ show: true, text, type });
//   };

//   const closeMessageModal = () => {
//     setMessage({ show: false, text: "", type: "" });
//   };

//   const formatDateForServer = (date) => {
//     if (!date) return "";
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${year}-${month}-${day}`;
//   };

//   // ---------- FETCH ----------
//   const fetchWithdrawalRequests = async (page = 1, filterData = filters) => {
//     setLoading(true);
//     const token = getAuthToken();

//     if (!token) {
//       showMessageModal("Authentication token not found.", "danger");
//       setLoading(false);
//       return;
//     }

//     const params = {
//       page,
//       limit: pagination.limit,
//       ...filterData,
//     };

//     if (filterFromDate) params.start_date = formatDateForServer(filterFromDate);
//     if (filterToDate) params.end_date = formatDateForServer(filterToDate);

//     try {
//       const response = await axios.get(`${API_URL}/withdrawal-requests-list`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params,
//       });

//       if (response.data.success === "1") {
//         setWithdrawals(response.data.data);
//         setPagination({
//           ...pagination,
//           currentPage: response.data.page,
//           totalPages: response.data.totalPages,
//           totalItems: response.data.total,
//         });
//       } else {
//         showMessageModal(
//           response.data.message || "Failed to fetch data.",
//           "danger",
//         );
//         setWithdrawals([]);
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       showMessageModal("An error occurred while fetching data.", "danger");
//       setWithdrawals([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchWithdrawalRequests(pagination.currentPage);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pagination.currentPage]);

//   const handleDateFilterSubmit = () => {
//     if (filterFromDate && filterToDate) {
//       const fromDate = new Date(formatDateForServer(filterFromDate));
//       const toDate = new Date(formatDateForServer(filterToDate));
//       if (fromDate > toDate) {
//         showMessageModal("From date cannot be greater than To date", "danger");
//         return;
//       }
//     }
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//     fetchWithdrawalRequests(1, filters);
//   };

//   const clearDateFilters = () => {
//     setFilterFromDate("");
//     setFilterToDate("");
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//     fetchWithdrawalRequests(1, filters);
//   };

//   const handlePageChange = (page) => {
//     if (page > 0 && page <= pagination.totalPages) {
//       setPagination((prev) => ({ ...prev, currentPage: page }));
//       fetchWithdrawalRequests(page);
//     }
//   };

//   // ---------- STATUS ----------
//   const handleStatusUpdateClick = (id, newStatus) => {
//     if (newStatus === "success") {
//       setRequestToUpdate({ id, newStatus });
//       setRemark("");
//       setSelectedPaymentMode("");
//       setPaymentUrl("");
//       setPaymentMethods("");
//       setSlipImage(null);
//       setApproveModalShow(true);
//     } else {
//       setRequestToUpdate({ id, newStatus });
//       setRemark("");
//       setStatusModalShow(true);
//     }
//   };

//   const updateRequestStatus = async () => {
//     if (!requestToUpdate) return;
//     setLoading(true);

//     try {
//       const token = getAuthToken();
//       if (!token) throw new Error("No authentication token found");

//       const url = `${API_URL}/withdrawal-requests-update-status`;
//       const config = {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       };
//       const data = {
//         request_id: requestToUpdate.id,
//         status: requestToUpdate.newStatus,
//         remark: remark,
//       };

//       const response = await axios.post(url, data, config);

//       if (response.data.success == 1) {
//         showMessageModal(response.data.message, "success");
//         fetchWithdrawalRequests(pagination.currentPage);
//       } else {
//         showMessageModal(
//           response.data.message || "Failed to update status.",
//           "danger",
//         );
//       }
//     } catch (error) {
//       console.error("Full error details:", error);
//       let errorMessage = "An error occurred while updating the status.";
//       if (error.response) {
//         errorMessage =
//           error.response.data?.error ||
//           error.response.statusText ||
//           `Server responded with ${error.response.status}`;
//       } else if (error.request) {
//         errorMessage = "No response received from server";
//       }
//       showMessageModal(errorMessage, "danger");
//     } finally {
//       setLoading(false);
//       setStatusModalShow(false);
//       setRequestToUpdate(null);
//       setRemark("");
//     }
//   };

//   const handleApproveSubmit = async () => {
//     if (!requestToUpdate) return;

//     const token = getAuthToken();
//     const formData = new FormData();
//     formData.append("request_id", requestToUpdate.id);
//     formData.append("status", "success");
//     formData.append("payment_utr", paymentUrl);
//     formData.append("payment_methods", PaymentMethods);
//     formData.append("remark", remark);

//     if (slipImage) formData.append("slip_image", slipImage);

//     try {
//       const response = await axios.post(
//         `${API_URL}/withdrawal-requests-update-status`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "multipart/form-data",
//           },
//         },
//       );

//       if (response.data.success == 1) {
//         showMessageModal(response.data.message, "success");
//         fetchWithdrawalRequests(pagination.currentPage);
//         setApproveModalShow(false);
//         setPaymentUrl("");
//         setPaymentMethods("");
//         setSlipImage(null);
//         setRequestToUpdate(null);
//         setRemark("");
//         setSelectedPaymentMode("");
//       } else {
//         showMessageModal(
//           response.data.message || "Failed to approve withdrawal",
//           "danger",
//         );
//       }
//     } catch (err) {
//       console.error(err);
//       showMessageModal("Error approving withdrawal", "danger");
//     }
//   };

//   // ---------- EXPORT ----------
//   const handleDownloadFilteredExcel = async () => {
//     const token = localStorage.getItem("token");

//     try {
//       Swal.fire({
//         title: "Please wait...",
//         text: "Generating your filtered Excel file",
//         allowOutsideClick: false,
//         didOpen: () => Swal.showLoading(),
//       });

//       const params = new URLSearchParams({
//         totalPages: pagination.totalPages,
//         start_date: formatDateForServer(filterFromDate),
//         end_date: formatDateForServer(filterToDate),
//       }).toString();

//       const response = await fetch(
//         `${API_URL}/download-withdrawal-pending-excel?${params}`,
//         {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         },
//       );

//       if (!response.ok) throw new Error("Failed to download Excel");

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Filtered Withdrawal Pending Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       Swal.fire({
//         icon: "success",
//         title: "Download Successful!",
//         text: "Filtered Excel report has been downloaded successfully.",
//         showConfirmButton: false,
//         timer: 2000,
//       });
//     } catch (error) {
//       console.error("Filtered Excel download failed:", error);
//       Swal.fire({
//         icon: "warning",
//         title: "Download Failed!",
//         text: "Please check the selected dates for downloading the report.",
//       });
//     }
//   };

//   // ---------- LOADING ----------
//   if (loading && withdrawals.length === 0) {
//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//         }}
//       >
//         <Spinner animation="border" role="status">
//           <span className="visually-hidden">Loading...</span>
//         </Spinner>
//       </div>
//     );
//   }

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               💸
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Commission Pending Requests
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Approve or reject pending withdrawal requests
//               </p>
//             </div>

//             <div className="d-flex gap-2 flex-wrap">
//               <Button
//                 className="d-flex gap-2 align-items-center"
//                 variant="primary"
//                 onClick={handleDownloadFilteredExcel}
//               >
//                 <BsFiletypeXls className="text-white fs-6" />
//                 Download
//               </Button>

//               <button
//                 className={`filter-toggle-btn btn ${
//                   isFilterActive ? "active" : ""
//                 }`}
//                 onClick={handleToggle}
//                 style={{
//                   width: "44px",
//                   height: "44px",
//                   borderRadius: "12px",
//                   border: "1.5px solid #e2e8f0",
//                   background: isFilterActive ? "#1e5799" : "#ffffff",
//                   color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: "20px",
//                   cursor: "pointer",
//                   transition: "all 0.25s ease",
//                   boxShadow: isFilterActive
//                     ? "0 8px 20px rgba(30, 87, 153, 0.3)"
//                     : "none",
//                 }}
//                 title={isFilterActive ? "Hide Filters" : "Show Filters"}
//               >
//                 {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//               </button>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background:
//                   "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* FILTER PANEL */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     background: "#f8fafc",
//                     border: "1.5px dashed #cbd5e1",
//                     borderRadius: "12px",
//                     padding: "20px",
//                     marginBottom: "24px",
//                   }}
//                 >
//                   <Row className="gy-3">
//                     <Col md={5} style={{ position: "relative" }}>
//                       <div
//                         className="position-absolute"
//                         style={{
//                           top: "8px",
//                           right: "20px",
//                           zIndex: 2,
//                           cursor: "pointer",
//                         }}
//                       >
//                         {!filterFromDate ? (
//                           <FaCalendar onClick={handleIconClick} />
//                         ) : (
//                           <FaTimes onClick={handleClear} />
//                         )}
//                       </div>
//                       <DatePicker
//                         ref={datePickerRef}
//                         selected={filterFromDate}
//                         onChange={(date) => setFilterFromDate(date)}
//                         placeholderText="From Date (DD-MM-YYYY)"
//                         dateFormat="dd-MM-yyyy"
//                         className="form-control"
//                         style={{ paddingLeft: "35px", paddingRight: "30px" }}
//                         showPopperArrow={false}
//                         showMonthDropdown
//                         showYearDropdown
//                         dropdownMode="select"
//                       />
//                     </Col>

//                     <Col md={5} style={{ position: "relative" }}>
//                       <DatePicker
//                         selected={filterToDate}
//                         onChange={(date) => setFilterToDate(date)}
//                         placeholderText="To Date (DD-MM-YYYY)"
//                         dateFormat="dd-MM-yyyy"
//                         className="form-control"
//                         style={{ paddingLeft: "35px", paddingRight: "30px" }}
//                         showPopperArrow={false}
//                         showMonthDropdown
//                         showYearDropdown
//                         dropdownMode="select"
//                       />
//                     </Col>

//                     <Col md={2} className="d-flex justify-content-start gap-2">
//                       <Button
//                         variant="primary"
//                         onClick={handleDateFilterSubmit}
//                       >
//                         <RiFilterFill /> Filter
//                       </Button>
//                     </Col>
//                   </Row>
//                 </div>
//               )}

//               {/* TABLE */}
//               {loading ? (
//                 <div className="text-center my-5">
//                   <Spinner animation="border" />
//                   <p className="mt-3">Loading withdrawal requests...</p>
//                 </div>
//               ) : (
//                 <>
//                   <Table striped bordered hover responsive className="shadow-sm">
//                     <thead>
//                       <tr>
//                         <th>ID</th>
//                         <th>Request Date</th>
//                         <th>Withdraw ID</th>
//                         <th>Name</th>
//                         <th>Mobile</th>
//                         <th>A/C Name</th>
//                         <th>Bank</th>
//                         <th>Branch Name</th>
//                         <th>Account Number</th>
//                         <th>IFSC Code</th>
//                         <th>Request Amount</th>
//                         <th>TDS %</th>
//                         <th>TDS Amount</th>
//                         <th>Net Amount (After TDS)</th>
//                         <th>Advance Payment</th>
//                         <th>Advance Payment Settled</th>
//                         <th>Remaining Advance Payment</th>
//                         <th>Net Payable Amount</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {withdrawals.length > 0 ? (
//                         withdrawals.map((item, index) => (
//                           <tr key={item.id}>
//                             <td>
//                               {(pagination.currentPage - 1) *
//                                 pagination.limit +
//                                 index +
//                                 1}
//                             </td>
//                             <td>
//                               {new Date(item.created_at)
//                                 .toLocaleDateString("en-GB")
//                                 .replace(/\//g, "-")}
//                             </td>
//                             <td>{item.withdraw_id}</td>
//                             <td>
//                               {item.username
//                                 ? item.username.charAt(0).toUpperCase() +
//                                   item.username.slice(1).toLowerCase()
//                                 : ""}
//                             </td>
//                             <td>{item.mobile}</td>
//                             <td>
//                               {item.account_holder_name
//                                 ? item.account_holder_name
//                                     .charAt(0)
//                                     .toUpperCase() +
//                                   item.account_holder_name
//                                     .slice(1)
//                                     .toLowerCase()
//                                 : ""}
//                             </td>
//                             <td>
//                               {item.bank_name
//                                 ? item.bank_name.charAt(0).toUpperCase() +
//                                   item.bank_name.slice(1).toLowerCase()
//                                 : ""}
//                             </td>
//                             <td>{item.bank_branch_name || "NA"}</td>
//                             <td>{item.account_number}</td>
//                             <td>{item.ifsc_code}</td>
//                             <td>₹ {item.amount || "0.00"}</td>
//                             <td>{item.tds_percent || "0.00"}</td>
//                             <td>₹ {item.tds || "0.00"}</td>
//                             <td>₹ {item.amount_after_tds || "0.00"}</td>
//                             <td>₹ {item.advance_payment || "0.00"}</td>
//                             <td>₹ {item.advance_payment_used || "0.00"}</td>
//                             <td>
//                               ₹{" "}
//                               {item.advance_payment -
//                                 item.advance_payment_used || "0.00"}
//                             </td>
//                             <td>₹ {item.net_payment || "0.00"}</td>
//                             <td>
//                               {item.status === "pending" && (
//                                 <div className="d-flex gap-2">
//                                   <Button
//                                     variant="success"
//                                     size="sm"
//                                     onClick={() =>
//                                       handleStatusUpdateClick(
//                                         item.id,
//                                         "success",
//                                       )
//                                     }
//                                   >
//                                     Approve
//                                   </Button>
//                                   <Button
//                                     variant="danger"
//                                     size="sm"
//                                     onClick={() =>
//                                       handleStatusUpdateClick(item.id, "reject")
//                                     }
//                                   >
//                                     Reject
//                                   </Button>
//                                 </div>
//                               )}
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td
//                             colSpan="19"
//                             className="text-center text-danger fw-bold"
//                           >
//                             No withdrawal requests found.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </Table>

//                   {/* PAGINATION */}
//                   <div className="d-flex justify-content-end mt-3">
//                     <Pagination>
//                       <Pagination.Prev
//                         onClick={() =>
//                           handlePageChange(pagination.currentPage - 1)
//                         }
//                         disabled={pagination.currentPage === 1}
//                       />
//                       <Pagination.Item
//                         active={1 === pagination.currentPage}
//                         onClick={() => handlePageChange(1)}
//                       >
//                         1
//                       </Pagination.Item>
//                       {pagination.currentPage > 3 && <Pagination.Ellipsis />}
//                       {[...Array(pagination.totalPages)].map((_, index) => {
//                         const pageNumber = index + 1;
//                         if (
//                           pageNumber > 1 &&
//                           pageNumber < pagination.totalPages &&
//                           Math.abs(pageNumber - pagination.currentPage) <= 1
//                         ) {
//                           return (
//                             <Pagination.Item
//                               key={pageNumber}
//                               active={pageNumber === pagination.currentPage}
//                               onClick={() => handlePageChange(pageNumber)}
//                             >
//                               {pageNumber}
//                             </Pagination.Item>
//                           );
//                         }
//                         return null;
//                       })}
//                       {pagination.currentPage < pagination.totalPages - 2 && (
//                         <Pagination.Ellipsis />
//                       )}
//                       {pagination.totalPages > 1 && (
//                         <Pagination.Item
//                           active={
//                             pagination.totalPages === pagination.currentPage
//                           }
//                           onClick={() =>
//                             handlePageChange(pagination.totalPages)
//                           }
//                         >
//                           {pagination.totalPages}
//                         </Pagination.Item>
//                       )}
//                       <Pagination.Next
//                         onClick={() =>
//                           handlePageChange(pagination.currentPage + 1)
//                         }
//                         disabled={
//                           pagination.currentPage === pagination.totalPages
//                         }
//                       />
//                     </Pagination>
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* 🎯 MESSAGE MODAL */}
//       <Modal show={message.show} onHide={closeMessageModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title
//             className={
//               message.type === "success" ? "text-success" : "text-danger"
//             }
//           >
//             {message.type === "success" ? "Success" : "Error"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{message.text}</Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={closeMessageModal}>
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 APPROVE MODAL */}
//       <Modal
//         show={approveModalShow}
//         onHide={() => {
//           setApproveModalShow(false);
//           setRemark("");
//           setSelectedPaymentMode("");
//           setPaymentUrl("");
//           setPaymentMethods("");
//           setSlipImage(null);
//         }}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Approve Withdrawal</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-3">
//               <Form.Label>
//                 Payment Mode<span className="text-danger"> *</span>
//               </Form.Label>
//               <Form.Select
//                 className="text-dark"
//                 value={PaymentMethods}
//                 onChange={(e) => {
//                   setPaymentMethods(e.target.value);
//                   setSelectedPaymentMode(e.target.value);
//                   if (e.target.value === "cash") {
//                     setPaymentUrl("");
//                     setSlipImage(null);
//                   }
//                 }}
//                 required
//               >
//                 <option value="">Select Payment Mode</option>
//                 <option value="cash">Cash</option>
//                 <option value="online">Online</option>
//               </Form.Select>
//             </Form.Group>

//             {selectedPaymentMode === "online" && (
//               <>
//                 <Form.Group className="mb-3">
//                   <Form.Label>
//                     Payment UTR <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     placeholder="Enter payment UTR"
//                     value={paymentUrl}
//                     onChange={(e) => setPaymentUrl(e.target.value)}
//                     required
//                   />
//                 </Form.Group>
//                 <Form.Group className="mb-3">
//                   <Form.Label>Slip Image</Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept="image/*"
//                     onChange={(e) => setSlipImage(e.target.files[0])}
//                   />
//                 </Form.Group>
//               </>
//             )}

//             <Form.Group className="mb-3">
//               <Form.Label>Remark (Optional)</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={2}
//                 placeholder="Enter any remarks..."
//                 value={remark}
//                 onChange={(e) => setRemark(e.target.value)}
//               />
//               <Form.Text className="text-muted">
//                 Add any additional remarks for this approval
//               </Form.Text>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => {
//               setApproveModalShow(false);
//               setRemark("");
//               setSelectedPaymentMode("");
//               setPaymentUrl("");
//               setPaymentMethods("");
//               setSlipImage(null);
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="success"
//             onClick={handleApproveSubmit}
//             disabled={
//               loading ||
//               (selectedPaymentMode === "online" && !paymentUrl.trim()) ||
//               !selectedPaymentMode
//             }
//           >
//             {loading ? (
//               <Spinner animation="border" size="sm" />
//             ) : (
//               "Confirm Approve"
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* 🎯 REJECT MODAL */}
//       <Modal
//         show={statusModalShow}
//         onHide={() => {
//           setStatusModalShow(false);
//           setRemark("");
//         }}
//         centered
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Reject Withdrawal</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <p className="mb-3 text-danger">
//               Are you sure you want to <strong>REJECT</strong> this withdrawal
//               request?
//             </p>
//             <Form.Group className="mb-3">
//               <Form.Label>
//                 Reason for Rejection<span className="text-danger">*</span>
//               </Form.Label>
//               <Form.Control
//                 as="textarea"
//                 rows={3}
//                 placeholder="Please provide reason for rejection..."
//                 value={remark}
//                 onChange={(e) => setRemark(e.target.value)}
//                 required
//               />
//               <Form.Text className="text-danger">
//                 This field is required for rejection
//               </Form.Text>
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button
//             variant="secondary"
//             onClick={() => {
//               setStatusModalShow(false);
//               setRemark("");
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="danger"
//             onClick={updateRequestStatus}
//             disabled={loading || !remark.trim()}
//           >
//             {loading ? (
//               <Spinner animation="border" size="sm" />
//             ) : (
//               "Confirm Reject"
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// }

// export default WithdrawlList;

import React, { useEffect, useState, useRef } from "react";
import { FaCalendar, FaTimes, FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { Modal, Form } from "react-bootstrap";
import axios from "axios";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
import { RiFilterFill } from "react-icons/ri";
import { BsFiletypeXls } from "react-icons/bs";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const API_URL = process.env.REACT_APP_API_URL;
const LIMIT = 10;

function WithdrawlList() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exporting, setExporting] = useState(false);
  const [filterFromDate, setFilterFromDate] = useState(null);
  const [filterToDate, setFilterToDate] = useState(null);
  const datePickerRef = useRef(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [filters, setFilters] = useState({
    name: "",
    account_number: "",
    status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [message, setMessage] = useState({ show: false, text: "", type: "" });
  const [statusModalShow, setStatusModalShow] = useState(false);
  const [requestToUpdate, setRequestToUpdate] = useState(null);
  const [approveModalShow, setApproveModalShow] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState("");
  const [PaymentMethods, setPaymentMethods] = useState("");
  const [slipImage, setSlipImage] = useState(null);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [remark, setRemark] = useState("");
  const [actionLoading, setActionLoading] = useState(false);

  const handleToggle = () => setIsFilterActive(!isFilterActive);
  const getAuthToken = () => localStorage.getItem("token");

  const showMessageModal = (text, type = "success") => {
    setMessage({ show: true, text, type });
  };

  const closeMessageModal = () => {
    setMessage({ show: false, text: "", type: "" });
  };

  const formatDateForServer = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH
  // ═══════════════════════════════════════════
  const fetchWithdrawalRequests = async (page = 1, filterData = filters) => {
    setLoading(true);
    const token = getAuthToken();

    if (!token) {
      showMessageModal("Authentication token not found.", "danger");
      setLoading(false);
      return;
    }

    const params = {
      page,
      limit: LIMIT,
      ...filterData,
    };

    if (filterFromDate) params.start_date = formatDateForServer(filterFromDate);
    if (filterToDate) params.end_date = formatDateForServer(filterToDate);

    try {
      const response = await axios.get(`${API_URL}/withdrawal-requests-list`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      if (response.data.success === "1") {
        setWithdrawals(response.data.data || []);
        setCurrentPage(Number(response.data.page) || page);
        setTotalPages(Number(response.data.totalPages) || 1);
        setTotalItems(Number(response.data.total) || 0);
      } else {
        showMessageModal(response.data.message || "Failed to fetch data.", "danger");
        setWithdrawals([]);
        setTotalPages(1);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("API Error:", error);
      showMessageModal("An error occurred while fetching data.", "danger");
      setWithdrawals([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWithdrawalRequests(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handleDateFilterSubmit = () => {
    if (filterFromDate && filterToDate) {
      const fromDate = new Date(formatDateForServer(filterFromDate));
      const toDate = new Date(formatDateForServer(filterToDate));
      if (fromDate > toDate) {
        showMessageModal("From date cannot be greater than To date", "danger");
        return;
      }
    }
    setCurrentPage(1);
    fetchWithdrawalRequests(1, filters);
  };

  const clearDateFilters = () => {
    setFilterFromDate(null);
    setFilterToDate(null);
    setCurrentPage(1);
    fetchWithdrawalRequests(1, filters);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // ═══════════════════════════════════════════
  // 🔹 STATUS UPDATE
  // ═══════════════════════════════════════════
  const handleStatusUpdateClick = (id, newStatus) => {
    if (newStatus === "success") {
      setRequestToUpdate({ id, newStatus });
      setRemark("");
      setSelectedPaymentMode("");
      setPaymentUrl("");
      setPaymentMethods("");
      setSlipImage(null);
      setApproveModalShow(true);
    } else {
      setRequestToUpdate({ id, newStatus });
      setRemark("");
      setStatusModalShow(true);
    }
  };

  const updateRequestStatus = async () => {
    if (!requestToUpdate) return;
    setActionLoading(true);

    try {
      const token = getAuthToken();
      if (!token) throw new Error("No authentication token found");

      const response = await axios.post(
        `${API_URL}/withdrawal-requests-update-status`,
        {
          request_id: requestToUpdate.id,
          status: requestToUpdate.newStatus,
          remark: remark,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success == 1) {
        Swal.fire({
          icon: "success",
          title: "Rejected!",
          text: response.data.message || "Withdrawal request rejected successfully.",
          timer: 1600,
          showConfirmButton: false,
        });
        fetchWithdrawalRequests(currentPage);
      } else {
        Swal.fire("Error", response.data.message || "Failed to update status.", "error");
      }
    } catch (error) {
      console.error("Full error details:", error);
      let errorMessage = "An error occurred while updating the status.";
      if (error.response) {
        errorMessage =
          error.response.data?.error ||
          error.response.statusText ||
          `Server responded with ${error.response.status}`;
      }
      Swal.fire("Error", errorMessage, "error");
    } finally {
      setActionLoading(false);
      setStatusModalShow(false);
      setRequestToUpdate(null);
      setRemark("");
    }
  };

  const handleApproveSubmit = async () => {
    if (!requestToUpdate) return;
    setActionLoading(true);

    const token = getAuthToken();
    const formData = new FormData();
    formData.append("request_id", requestToUpdate.id);
    formData.append("status", "success");
    formData.append("payment_utr", paymentUrl);
    formData.append("payment_methods", PaymentMethods);
    formData.append("remark", remark);
    if (slipImage) formData.append("slip_image", slipImage);

    try {
      const response = await axios.post(
        `${API_URL}/withdrawal-requests-update-status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success == 1) {
        Swal.fire({
          icon: "success",
          title: "Approved!",
          text: response.data.message || "Withdrawal approved successfully.",
          timer: 1600,
          showConfirmButton: false,
        });
        fetchWithdrawalRequests(currentPage);
        setApproveModalShow(false);
        setPaymentUrl("");
        setPaymentMethods("");
        setSlipImage(null);
        setRequestToUpdate(null);
        setRemark("");
        setSelectedPaymentMode("");
      } else {
        Swal.fire("Error", response.data.message || "Failed to approve withdrawal", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Error approving withdrawal", "error");
    } finally {
      setActionLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 EXPORT
  // ═══════════════════════════════════════════
  const handleDownloadFilteredExcel = async () => {
    const token = localStorage.getItem("token");

    try {
      Swal.fire({
        title: "Please wait...",
        text: "Generating your filtered Excel file",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const params = new URLSearchParams({
        totalPages: totalPages,
        start_date: formatDateForServer(filterFromDate),
        end_date: formatDateForServer(filterToDate),
      }).toString();

      const response = await fetch(
        `${API_URL}/download-withdrawal-pending-excel?${params}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) throw new Error("Failed to download Excel");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Filtered Withdrawal Pending Report.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.fire({
        icon: "success",
        title: "Download Successful!",
        text: "Filtered Excel report has been downloaded successfully.",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Filtered Excel download failed:", error);
      Swal.fire({
        icon: "warning",
        title: "Download Failed!",
        text: "Please check the selected dates for downloading the report.",
      });
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION HELPER
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🔹 LOADING
  // ═══════════════════════════════════════════
  if (loading && withdrawals.length === 0) {
    return (
      <div
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        }}
      >
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "4px solid #e2e8f0",
            borderTop: "4px solid #1e5799",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <style>{`@keyframes spin { from {transform:rotate(0deg);} to {transform:rotate(360deg);} }`}</style>
      </div>
    );
  }

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1600px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                  flexShrink: 0,
                }}
              >
                💸
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                  }}
                >
                  Commission Pending Requests
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Approve or reject pending withdrawal requests ({totalItems} total)
                </p>
              </div>
            </div>

            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <button
                onClick={handleDownloadFilteredExcel}
                style={{
                  padding: "10px 18px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #059669, #047857)",
                  color: "#ffffff",
                  fontWeight: "700",
                  fontSize: "13px",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  boxShadow: "0 4px 12px rgba(5, 150, 105, 0.25)",
                }}
              >
                <BsFiletypeXls size={16} /> Download
              </button>

              <button
                onClick={handleToggle}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "10px",
                  border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                  background: isFilterActive
                    ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                    : "#ffffff",
                  color: isFilterActive ? "#ffffff" : "#1e5799",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  cursor: "pointer",
                  boxShadow: isFilterActive
                    ? "0 6px 18px rgba(30, 87, 153, 0.3)"
                    : "none",
                }}
                title="Toggle Filters"
              >
                {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
              </button>
            </div>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filter Panel */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    flexWrap: "wrap",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: 1, minWidth: "180px", position: "relative" }}>
                    <label style={labelStyle}>From Date</label>
                    <div style={{ position: "relative" }}>
                      <DatePicker
                        ref={datePickerRef}
                        selected={filterFromDate}
                        onChange={(date) => setFilterFromDate(date)}
                        placeholderText="DD-MM-YYYY"
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        style={inputStyle}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "14px",
                          cursor: "pointer",
                          color: "#64748b",
                        }}
                      >
                        {filterFromDate ? (
                          <FaTimes onClick={() => setFilterFromDate(null)} />
                        ) : (
                          <FaCalendar onClick={() => datePickerRef.current?.setOpen(true)} />
                        )}
                      </div>
                    </div>
                  </div>

                  <div style={{ flex: 1, minWidth: "180px" }}>
                    <label style={labelStyle}>To Date</label>
                    <DatePicker
                      selected={filterToDate}
                      onChange={(date) => setFilterToDate(date)}
                      placeholderText="DD-MM-YYYY"
                      dateFormat="dd-MM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      style={inputStyle}
                    />
                  </div>

                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      onClick={handleDateFilterSubmit}
                      style={{
                        padding: "10px 22px",
                        borderRadius: "10px",
                        border: "none",
                        background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        color: "#ffffff",
                        fontWeight: "700",
                        cursor: "pointer",
                        height: "42px",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <RiFilterFill /> Filter
                    </button>
                    <button
                      onClick={clearDateFilters}
                      style={{
                        padding: "10px 18px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: "#64748b",
                        fontWeight: "700",
                        cursor: "pointer",
                        height: "42px",
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Table */}
            <div
              style={{
                overflowX: "auto",
                overflowY: "visible",
                borderRadius: "14px",
                border: "1.5px solid #e2e8f0",
              }}
            >
              <table
                style={{
                  width: "100%",
                  minWidth: "1800px",
                  borderCollapse: "collapse",
                  fontSize: "13px",
                }}
              >
                <thead>
                  <tr
                    style={{
                      background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                    }}
                  >
                    {[
                      "S.N",
                      "Request Date",
                      "Withdraw ID",
                      "Name",
                      "Mobile",
                      "A/C Name",
                      "Bank",
                      "Branch",
                      "Account Number",
                      "IFSC",
                      "Request Amount",
                      "TDS %",
                      "TDS Amount",
                      "Net After TDS",
                      "Advance Payment",
                      "Advance Settled",
                      "Remaining Advance",
                      "Net Payable",
                      "Action",
                    ].map((th, i) => (
                      <th
                        key={i}
                        style={{
                          padding: "14px 12px",
                          color: "#ffffff",
                          fontWeight: "700",
                          fontSize: "11.5px",
                          textAlign: "left",
                          letterSpacing: "0.5px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {th}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="19" style={{ padding: "50px", textAlign: "center" }}>
                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            border: "4px solid #e2e8f0",
                            borderTop: "4px solid #1e5799",
                            borderRadius: "50%",
                            animation: "spin 0.8s linear infinite",
                            margin: "0 auto",
                          }}
                        />
                      </td>
                    </tr>
                  ) : withdrawals.length > 0 ? (
                    withdrawals.map((item, index) => (
                      <tr
                        key={item.id}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f8fafc")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "transparent")
                        }
                      >
                        <td style={cellBlue}>
                          {(currentPage - 1) * LIMIT + index + 1}
                        </td>
                        <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                          {item.created_at
                            ? new Date(item.created_at)
                                .toLocaleDateString("en-GB")
                                .replace(/\//g, "-")
                            : "-"}
                        </td>
                        <td style={cellGray}>{item.withdraw_id || "-"}</td>
                        <td style={cellDark}>
                          {item.username
                            ? item.username.charAt(0).toUpperCase() +
                              item.username.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>{item.mobile || "-"}</td>
                        <td style={cellDark}>
                          {item.account_holder_name
                            ? item.account_holder_name.charAt(0).toUpperCase() +
                              item.account_holder_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellDark}>
                          {item.bank_name
                            ? item.bank_name.charAt(0).toUpperCase() +
                              item.bank_name.slice(1).toLowerCase()
                            : "-"}
                        </td>
                        <td style={cellGray}>{item.bank_branch_name || "NA"}</td>
                        <td style={cellGray}>{item.account_number || "-"}</td>
                        <td style={cellGray}>{item.ifsc_code || "-"}</td>
                        <td style={cellDark}>₹ {item.amount || "0.00"}</td>
                        <td style={cellGray}>{item.tds_percent || "0.00"}</td>
                        <td style={cellGray}>₹ {item.tds || "0.00"}</td>
                        <td style={cellDark}>₹ {item.amount_after_tds || "0.00"}</td>
                        <td style={cellGray}>₹ {item.advance_payment || "0.00"}</td>
                        <td style={cellGray}>₹ {item.advance_payment_used || "0.00"}</td>
                        <td style={cellGray}>
                          ₹{" "}
                          {(item.advance_payment || 0) -
                            (item.advance_payment_used || 0) || "0.00"}
                        </td>
                        <td style={{ ...cellDark, fontWeight: "700" }}>
                          ₹ {item.net_payment || "0.00"}
                        </td>
                        <td style={{ padding: "12px" }}>
                          {item.status === "pending" && (
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <button
                                onClick={() =>
                                  handleStatusUpdateClick(item.id, "success")
                                }
                                style={{
                                  padding: "7px 14px",
                                  borderRadius: "8px",
                                  border: "none",
                                  background:
                                    "linear-gradient(135deg, #059669, #047857)",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  fontWeight: "700",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  boxShadow:
                                    "0 4px 12px rgba(5, 150, 105, 0.25)",
                                }}
                              >
                                <FaCheckCircle size={12} /> Approve
                              </button>
                              <button
                                onClick={() =>
                                  handleStatusUpdateClick(item.id, "reject")
                                }
                                style={{
                                  padding: "7px 14px",
                                  borderRadius: "8px",
                                  border: "none",
                                  background:
                                    "linear-gradient(135deg, #dc2626, #b91c1c)",
                                  color: "#ffffff",
                                  fontSize: "12px",
                                  fontWeight: "700",
                                  cursor: "pointer",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  boxShadow:
                                    "0 4px 12px rgba(220, 38, 38, 0.25)",
                                }}
                              >
                                <FaTimesCircle size={12} /> Reject
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="19"
                        style={{
                          padding: "50px",
                          textAlign: "center",
                          color: "#94a3b8",
                          fontWeight: "600",
                        }}
                      >
                        📭 No withdrawal requests found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "24px",
                  gap: "6px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor: currentPage === 1 ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  ‹ Prev
                </button>

                {getPageNumbers().map((p, i) => {
                  if (p === "left-ellipsis" || p === "right-ellipsis") {
                    return (
                      <span
                        key={`ellipsis-${i}`}
                        style={{
                          padding: "0 6px",
                          color: "#94a3b8",
                          fontWeight: "700",
                        }}
                      >
                        ...
                      </span>
                    );
                  }
                  const isActive = p === currentPage;
                  return (
                    <button
                      key={p}
                      onClick={() => handlePageChange(p)}
                      style={{
                        minWidth: "38px",
                        height: "38px",
                        borderRadius: "10px",
                        border: isActive ? "none" : "1.5px solid #e2e8f0",
                        background: isActive
                          ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                          : "#ffffff",
                        color: isActive ? "#ffffff" : "#334155",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: "pointer",
                        boxShadow: isActive
                          ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                          : "none",
                        transition: "all 0.18s ease",
                      }}
                    >
                      {p}
                    </button>
                  );
                })}

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  style={{
                    padding: "8px 14px",
                    borderRadius: "10px",
                    border: "1.5px solid #e2e8f0",
                    background: "#ffffff",
                    color: currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                    fontWeight: "700",
                    fontSize: "13px",
                    cursor:
                      currentPage === totalPages ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  Next ›
                </button>
              </div>
            )}

            {totalItems > 0 && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "12px",
                  color: "#94a3b8",
                  marginTop: "12px",
                  marginBottom: 0,
                  fontWeight: "500",
                }}
              >
                Page {currentPage} of {totalPages} • {totalItems} total records
              </p>
            )}
          </div>
        </div>

        {/* Footer */}
        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "12.5px",
            marginTop: "24px",
            fontWeight: "500",
          }}
        >
          © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
          Reserved.
        </p>
      </div>

      {/* ═══════════════════════════════════════════ */}
      {/* MESSAGE MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal show={message.show} onHide={closeMessageModal} centered>
        <Modal.Header
          closeButton
          style={{
            background: message.type === "success" ? "#059669" : "#dc2626",
            color: "#ffffff",
            border: "none",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            {message.type === "success" ? "✅ Success" : "⚠️ Error"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px", textAlign: "center", fontWeight: "600" }}>
          {message.text}
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: "center", borderTop: "1.5px solid #e2e8f0" }}>
          <button
            onClick={closeMessageModal}
            style={{
              padding: "10px 28px",
              borderRadius: "10px",
              border: "none",
              background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
              color: "#ffffff",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* APPROVE MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={approveModalShow}
        onHide={() => {
          setApproveModalShow(false);
          setRemark("");
          setSelectedPaymentMode("");
          setPaymentUrl("");
          setPaymentMethods("");
          setSlipImage(null);
        }}
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{
            background: "#059669",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ✅ Approve Withdrawal
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700", color: "#1e3a5f" }}>
                Payment Mode <span style={{ color: "#dc2626" }}>*</span>
              </Form.Label>
              <Form.Select
                value={PaymentMethods}
                onChange={(e) => {
                  setPaymentMethods(e.target.value);
                  setSelectedPaymentMode(e.target.value);
                  if (e.target.value === "cash") {
                    setPaymentUrl("");
                    setSlipImage(null);
                  }
                }}
                style={inputStyle}
              >
                <option value="">Select Payment Mode</option>
                <option value="cash">Cash</option>
                <option value="online">Online</option>
              </Form.Select>
            </Form.Group>

            {selectedPaymentMode === "online" && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: "700", color: "#1e3a5f" }}>
                    Payment UTR <span style={{ color: "#dc2626" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter payment UTR"
                    value={paymentUrl}
                    onChange={(e) => setPaymentUrl(e.target.value)}
                    style={inputStyle}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label style={{ fontWeight: "700", color: "#1e3a5f" }}>
                    Slip Image
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={(e) => setSlipImage(e.target.files[0])}
                    style={inputStyle}
                  />
                </Form.Group>
              </>
            )}

            <Form.Group className="mb-3">
              <Form.Label style={{ fontWeight: "700", color: "#1e3a5f" }}>
                Remark (Optional)
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                placeholder="Enter any remarks..."
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                style={inputStyle}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => {
              setApproveModalShow(false);
              setRemark("");
              setSelectedPaymentMode("");
              setPaymentUrl("");
              setPaymentMethods("");
              setSlipImage(null);
            }}
            disabled={actionLoading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleApproveSubmit}
            disabled={
              actionLoading ||
              (selectedPaymentMode === "online" && !paymentUrl.trim()) ||
              !selectedPaymentMode
            }
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background:
                actionLoading ||
                (selectedPaymentMode === "online" && !paymentUrl.trim()) ||
                !selectedPaymentMode
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #059669, #047857)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor:
                actionLoading ||
                (selectedPaymentMode === "online" && !paymentUrl.trim()) ||
                !selectedPaymentMode
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {actionLoading ? "Processing..." : "Yes, Approve"}
          </button>
        </Modal.Footer>
      </Modal>

      {/* ═══════════════════════════════════════════ */}
      {/* REJECT MODAL */}
      {/* ═══════════════════════════════════════════ */}
      <Modal
        show={statusModalShow}
        onHide={() => {
          setStatusModalShow(false);
          setRemark("");
        }}
        centered
        backdrop="static"
      >
        <Modal.Header
          closeButton
          style={{
            background: "#dc2626",
            color: "#ffffff",
            border: "none",
            padding: "18px 24px",
          }}
        >
          <Modal.Title style={{ fontWeight: "800", fontSize: "18px" }}>
            ⚠️ Reject Withdrawal
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "24px" }}>
          <p style={{ textAlign: "center", fontWeight: "600", marginBottom: "16px" }}>
            Are you sure you want to{" "}
            <strong style={{ color: "#dc2626" }}>REJECT</strong> this withdrawal request?
          </p>
          <Form.Group>
            <Form.Label style={{ fontWeight: "700", color: "#1e3a5f" }}>
              Reason for Rejection <span style={{ color: "#dc2626" }}>*</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Please provide reason for rejection..."
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              style={inputStyle}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1.5px solid #e2e8f0",
            padding: "16px 24px",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => {
              setStatusModalShow(false);
              setRemark("");
            }}
            disabled={actionLoading}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "1.5px solid #e2e8f0",
              background: "#ffffff",
              color: "#64748b",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading ? "not-allowed" : "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={updateRequestStatus}
            disabled={actionLoading || !remark.trim()}
            style={{
              padding: "10px 22px",
              borderRadius: "10px",
              border: "none",
              background:
                actionLoading || !remark.trim()
                  ? "#cbd5e1"
                  : "linear-gradient(135deg, #dc2626, #b91c1c)",
              color: "#ffffff",
              fontSize: "13px",
              fontWeight: "700",
              cursor: actionLoading || !remark.trim() ? "not-allowed" : "pointer",
            }}
          >
            {actionLoading ? "Processing..." : "Yes, Reject"}
          </button>
        </Modal.Footer>
      </Modal>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .react-datepicker-wrapper {
          width: 100%;
        }
        .react-datepicker__input-container input {
          width: 100%;
          padding: 10px 14px;
          border-radius: 10px;
          border: 1.5px solid #e2e8f0;
          font-size: 13.5px;
          font-weight: 500;
          color: #1e3a5f;
          outline: none;
          box-sizing: border-box;
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };

export default WithdrawlList;